import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';
import '../styles/AuthPages.css';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  // ✅ Verify email token from URL
  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const token = searchParams.get('token');
        const email = searchParams.get('email');

        if (!token || !email) {
          setError('Invalid verification link. Missing token or email.');
          setLoading(false);
          return;
        }

        // Call backend to verify email
        const response = await authApi.verifyEmail({ token, email });

        if (response.success) {
          setSuccess(true);
          setError('');
          // Redirect to login after 3 seconds
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          setError(response.message || 'Verification failed. Please try again.');
        }
      } catch (err) {
        setError(err.message || 'An error occurred during verification.');
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="auth-container verify-email-page">
      <div className="auth-card">
        <h1>Email Verification</h1>

        {loading && (
          <div className="verify-loading">
            <div className="spinner"></div>
            <p>Verifying your email...</p>
          </div>
        )}

        {success && (
          <div className="verify-success">
            <div className="success-icon">✓</div>
            <h2>Email Verified Successfully!</h2>
            <p>Your email has been confirmed. You can now log in.</p>
            <p className="redirect-message">Redirecting to login page...</p>
          </div>
        )}

        {error && !loading && (
          <div className="verify-error">
            <div className="error-icon">✕</div>
            <h2>Verification Failed</h2>
            <p>{error}</p>
            <button 
              className="btn-primary"
              onClick={() => navigate('/login')}
            >
              Back to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
